<div class="pt-3 pb-5 model">
  <app-section-container [isCarausalAvailable]="true">
    <app-section-heading>
      <span class="text__black"> Models</span>
    </app-section-heading>
    <div>
      <app-section-description>
        <span class="text__black">
          {{ description }}
        </span>
      </app-section-description>
    </div>
    <div
      class="d-flex align-items-center justify-content-md-center justify-content-start gap-2 py-3 model-chip"
    >
      <div
        class="chip"
        [ngClass]="{
          selected: selectedCategory === CategoryTypes.trending,
        }"
        (click)="
          selectedCategory = CategoryTypes.trending;
          fetchModels(selectedCategory)
        "
        title="Trending"
      >
        <app-card-chips
          ><span ngProjectAs="[chip-icon]">
            @if (selectedCategory === CategoryTypes.trending) {
              <img
                src="images/trending.svg"
                height="24"
                width="24"
                alt="trending"
              />
            } @else {
              <img
                src="images/trending-black.svg"
                height="24"
                width="24"
                alt="trending"
              />
            }</span
          >Trending</app-card-chips
        >
      </div>
      <div
        class="chip"
        [ngClass]="{
          selected: selectedCategory === CategoryTypes.downloads,
        }"
        (click)="
          selectedCategory = CategoryTypes.downloads;
          fetchModels(selectedCategory)
        "
        title="Most Downloaded"
      >
        <app-card-chips
          ><span ngProjectAs="[chip-icon]">
            @if (selectedCategory === CategoryTypes.downloads) {
              <img
                src="images/download-white-icon.svg"
                height="24"
                width="24"
                alt="Download"
              />
            } @else {
              <img
                src="images/download-black.svg"
                height="24"
                width="24"
                alt="Download"
              />
            }</span
          >Most Download</app-card-chips
        >
      </div>
      <div
        class="chip"
        [ngClass]="{
          selected: selectedCategory === CategoryTypes.new,
        }"
        (click)="
          selectedCategory = CategoryTypes.new; fetchModels(selectedCategory)
        "
        title="New on AIKosh"
      >
        <app-card-chips>
          <span ngProjectAs="[chip-icon]">
            @if (selectedCategory === CategoryTypes.new) {
              <img src="images/star-white.svg" height="24" width="25" alt="" />
            } @else {
              <img src="images/star.svg" height="24" width="25" alt="star" />
            }
          </span>
          New on AIKosh</app-card-chips
        >
      </div>
      <div
        class="chip"
        [ngClass]="{
          selected: selectedCategory === CategoryTypes.openModel,
        }"
        (click)="
          selectedCategory = CategoryTypes.openModel;
          fetchModels(this.selectedCategory)
        "
        title="Dataset"
      >
        <app-card-chips>
          <span ngProjectAs="[chip-icon]">
            @if (selectedCategory === CategoryTypes.openModel) {
              <img
                src="images/open-dataset.svg"
                height="24"
                width="24"
                alt="24"
                alt="open dataset"
              />
            } @else {
              <img
                src="images/open-dataset.svg"
                height="24"
                width="24"
                alt="24"
                alt="open dataset"
              />
            }</span
          >Open Models</app-card-chips
        >
      </div>
      <a
        class="view-all text-decoration-none"
        [routerLink]="['/', routes.home, routes.models, routes.all]"
        title="View All"
      >
        <app-card-chips>
          <img src="images/view-all.svg" height="24" width="25" alt="vie-all" />
          View All</app-card-chips
        >
      </a>
    </div>
    <div class="position-relative pt-5">
      <button
        [ngStyle]="{ visibility: !models?.length ? 'hidden' : 'visible' }"
        class="d-flex align-items-center justify-content-center position-absolute hero-carousel-arrow hero-carousel-arrow--prev"
      >
        <img
          src="images/prev-arrow.svg"
          height="14"
          width="10"
          alt="prev arrow"
        />
      </button>

      <div
        class="d-flex align-items-center justify-content-center gap-3"
        [ngClass]="isModelsLoading ? 'd-block' : 'd-none'"
      >
        <app-card-skeleton-loader
          [cardType]="CardType.model"
        ></app-card-skeleton-loader>
        <div class="d-none d-sm-block">
          <app-card-skeleton-loader
            [cardType]="CardType.model"
          ></app-card-skeleton-loader>
        </div>
        <div class="d-none d-md-block">
          <app-card-skeleton-loader
            [cardType]="CardType.model"
          ></app-card-skeleton-loader>
        </div>
        <div class="d-none d-md-block">
          <app-card-skeleton-loader
            [cardType]="CardType.model"
          ></app-card-skeleton-loader>
        </div>
      </div>

      <div [ngClass]="!isModelsLoading ? 'swiper-section d-block' : 'd-none'">
        <swiper-container
          #swiperContainerModel
          id="model-swiper-container"
          init="false"
        >
          @for (model of models; track model.id) {
            <swiper-slide>
              <div class="hero-carousel h-100">
                <app-model-card
                  [modelItem]="model"
                  (onVoteButtonClicked)="fetchModels(selectedCategory)"
                ></app-model-card>
              </div>
            </swiper-slide>
          }
        </swiper-container>

        <ng-container *ngIf="!models?.length">
          <ng-container *ngIf="isErrorFetchingModels; else noRecordFound">
            <app-couldnt-load-data
              minHeight="25rem"
              (onRetry)="fetchModels(selectedCategory)"
            ></app-couldnt-load-data>
          </ng-container>

          <ng-template #noRecordFound>
            <app-no-record-found></app-no-record-found>
          </ng-template>
        </ng-container>
      </div>

      <button
        [ngStyle]="{ visibility: !models?.length ? 'hidden' : 'visible' }"
        class="d-flex align-items-center justify-content-center position-absolute hero-carousel-arrow hero-carousel-arrow--next"
      >
        <img width="10" height="14" src="images/next-arrow.svg" alt="Next" />
      </button>
      <div class="model-swiper-pagination swiper-pagination"></div>
    </div>
  </app-section-container>
  <!-- <div
    class="model-chip d-flex align-items-center justify-content-center mt-5 mb-4"
  >
    <a
      class="view-all text-decoration-none"
      [routerLink]="['/', routes.home, routes.models, routes.all]"
      title="View All"
    >
      <app-card-chips>
        <img src="images/view-all.svg" height="24" width="25" alt="vie-all" />
        View All</app-card-chips
      >
    </a>
  </div> -->
</div>
